import { TableRow } from '@material-ui/core';
import { Events } from '@type-r/models';
import { Linked, useLinked } from '@type-r/react';
import { InlineTable, PopupIODialog, TableCell, TableHeader } from 'lqx-react';
import * as React from 'react';
import { CompanyModel, PlatformCompany, RelationshipModel } from 'api';
import { UnresolvedPayment } from '../../api/unresolvedPayment';

export const ResolvePaymentRelationshipDialog = ({ $resolving, payment, customer, supplier } : {
    $resolving : Linked<boolean>,
    payment : UnresolvedPayment,
    customer : PlatformCompany,
    supplier : PlatformCompany
}) => {
    const $resolvedCount = useLinked( 0 );

    return (
        <PopupIODialog
            $isOpen={ Linked.value( $resolving.isTruthy, x => !x ? $resolving.null() : undefined ) }
            title="Resolve payments"
            actionLabel="Resolve"
            width={800}
            success={
                <p>
                    { $resolvedCount.value } payments were resolved.
                </p>
            }
            doIO={ async () => {
                // TODO: Update relationship (supplier, customer, $resolving.value)

                $resolvedCount.set( await payment.resolveAll( customer.id, supplier.id, payment.id ) );
            }}

            onSuccess={
                () => Events.trigger( "bankTransactionSummary:refresh" )
            }
        >
            { $resolving.value ? <p>Companies info will be updated </p> : undefined }
            
            <InlineTable>
                <TableHeader>
                    <TableCell/>
                    <TableCell>{supplier.name}</TableCell>
                    <TableCell>{customer.name}</TableCell>
                </TableHeader>
                <TableRow>
                    <TableCell>Name Alias</TableCell>
                    <TableCell>{payment.supplier.name}</TableCell>
                    <TableCell>{payment.customer.name}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Bank Account</TableCell>
                    <TableCell>{payment.supplier.account}</TableCell>
                    <TableCell>{payment.customer.account}</TableCell>
                </TableRow>
            </InlineTable>
            <p> Selected payment will be resolved.</p>
        </PopupIODialog>
    )
}